<template>
     <div class="page-content">
          <div class="content-wrapper">

               <!-- Page header -->
               <div class="page-header mb-2">
                    <div class="page-header-content header-elements-md-inline">
                         <div class="page-title d-flex">
                              <h4 class="font-weight-semibold">User Management</h4>
                         </div>
                         <div class="d-flex">
                              <button v-b-modal.create-user-modal type="button" id="create-modal" class="btn btn-primary">Create</button>
                         </div>
                    </div>
               </div>
               <!-- /page header -->

               <!-- Content area -->
               <div class="content pt-0">
                    <div class="row">
                         <div class="col-xl-12">
                              <div class="card">
                                   <div class="table-responsive">
                                        <table class="table">
                                             <thead>
                                                  <tr>
                                                       <th>#</th>
                                                       <th>Role</th>
                                                       <th>Username</th>
                                                       <th>Status</th>
                                                       <th>Created at</th>
                                                       <th>Action</th>
                                                  </tr>
                                             </thead>
                                             <tbody>
                                                  <tr v-if="isLoading">
                                                       <td colspan="8">
                                                       <loading></loading>
                                                       </td>
                                                  </tr>
                                                  <tr v-else v-for="(user, idx) in users" :key="user._id">
                                                       <td>{{idx+1}}</td>
                                                       <td>{{user.role}}</td>
                                                       <td>{{user.username}}</td>
                                                       <td><span class="badge badge-pill badge-flat" :class="{'border-warning text-warning':user.status==='request_approver','border-success text-success':user.status==='active','border-grey text-muted':user.status === 'inactive'}">{{ user.status }}</span></td>
                                                       <td>{{moment(user.createdAt).format('DD/MM/YYYY HH:mm')}}</td>
                                                       <td>

                                                            <router-link :to="`/usermanagement/${user._id}/edit`"><i class="far fa-edit text-dark"></i></router-link>
                                                            <button type="button" class="btn" @click="deleteAccount(user._id)"><i class="far fa-trash-alt  text-dark"></i></button>
                                                       </td>
                                                  </tr>
                                             </tbody>
                                        </table>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
                <!-- /content area -->

               <!-- Create User Modal -->
               <b-modal centered id="create-user-modal" ref="createmodal" size="sm" title="New User" hide-backdrop no-close-on-backdrop>
                    <form>
                         <div class="form-group">
                              <label for="createUsername" class="d-block font-weight-semibold">Username</label>
                              <input type="text" class="form-control" id="createUsername" placeholder="Username" v-model="newUser.username">
                         </div>
                         <div class="form-group">
                              <label for="createPassword" class="d-block font-weight-semibold">Password</label>
                              <input type="password" class="form-control" id="createPassword" placeholder="Password" v-model="newUser.password">
                         </div>
                         <div class="form-group">
                              <label class="d-block font-weight-semibold">Role</label>
                              <div class="form-check form-check-inline">
                                   <label class="form-check-label">
                                        <input type="radio" class="form-check-input" name="radio-unstyled-inline-left" value="admin" v-model="newUser.role">
                                        Admin
                                   </label>
                              </div>
                              <div class="form-check form-check-inline">
                                   <label class="form-check-label">
                                        <input type="radio" class="form-check-input" name="radio-unstyled-inline-left" value="user" v-model="newUser.role">
                                        User
                                   </label>
                              </div>
                         </div>
                         <div class="form-group">
                              <label class="d-block font-weight-semibold">Status</label>
                              <div class="form-check form-check-inline">
                                   <label class="form-check-label">
                                        <input type="checkbox" class="form-check-input" v-model="newUser.status">
                                        Active
                                   </label>
                              </div>
                         </div>
                         <!-- <b-form-group label="Username" label-for="createUsername" class="d-block font-weight-semibold">
                              <b-form-input id="createUsername" trim placeholder="Username" v-model="newUser.username"></b-form-input>
                         </b-form-group> -->
                    </form>
                    <template v-slot:modal-footer>
                         <div>
                              <button type="button" class="btn btn-link" @click="resetCreateModal()">Cancel</button>
                              <button type="button" class="btn bg-primary" @click="createNewUser" :disabled="!validInput">Create</button>
                         </div>
                    </template>
               </b-modal>

               <!-- Edit User Modal -->
               <b-modal centered id="edit-user-modal" ref="editmodal" size="sm" title="Edit" hide-backdrop no-close-on-backdrop>
                    <form>
                         <div class="form-group">
                              <label for="editUsername" class="d-block font-weight-semibold">Username</label>
                              <input type="text" class="form-control" id="editUsername" placeholder="Username" v-model="editUser.username" disabled >
                         </div>
                         <div class="form-group">
                              <label class="d-block font-weight-semibold">Role</label>
                              <div class="form-check form-check-inline">
                                   <label class="form-check-label">
                                        <input type="radio" class="form-check-input" name="radio-unstyled-inline-left" value="admin" :checked="editUser.role === 'admin'" v-model="editUser.role">
                                        Admin
                                   </label>
                              </div>
                              <div class="form-check form-check-inline">
                                   <label class="form-check-label">
                                        <input type="radio" class="form-check-input" name="radio-unstyled-inline-left" value="user" :checked="editUser.role === 'user'" v-model="editUser.role">
                                        User
                                   </label>
                              </div>
                         </div>
                         <div class="form-group">
                              <label class="d-block font-weight-semibold">Status</label>
                              <div class="form-check form-check-inline">
                                   <label class="form-check-label">
                                        <input type="checkbox" class="form-check-input" v-model="editUser.status">
                                        Active
                                   </label>
                              </div>
                              <hr>
                              <div class="form-group">
                                   <label for="adminPassword" class="d-block font-weight-semibold">Confirm Admin Password</label>
                                   <input type="password" class="form-control" id="adminPassword" placeholder="Confirm Admin Password" v-model="adminPassword" :class="{ 'form-control border-danger': !isValidPassword}">
                                   <span v-if="!isValidPassword" class="form-text text-danger">Password is Invalid</span>
                              </div>
                         </div>
                    </form>
                    <template v-slot:modal-footer>
                         <div>
                              <button type="button" class="btn btn-link" @click="resetEditModal()">Cancel</button>
                              <button type="button" class="btn bg-primary" @click="saveUpdateUser" :disabled="!validPassword">Save</button>
                         </div>
                    </template>
               </b-modal>

          </div>
     </div>
</template>
<script>
import Swal from 'sweetalert2'
import { mapActions, mapGetters } from 'vuex'
import { BModal, VBModal } from 'bootstrap-vue'
import Loading from '../components/Loading'
import moment from 'moment'
export default {
  components: {
    Loading,
    'b-modal': BModal
  },
  directives: {
    'b-modal': VBModal
  },
  data () {
    return {
      isLoading: true,
      users: null,
      userDetail: {},
      editUser: {},
      newUser: {
        username: '',
        password: '',
        role: 'user',
        status: true
      },
      adminPassword: null,
      isValidPassword: true
    }
  },
  async mounted () {
    this.users = await this.getUsers()
    this.isLoading = false
  },
  computed: {
    ...mapGetters({ isAuth: 'isAuth', username: 'username' }),
    validInput () {
      return this.newUser.username && this.newUser.password && this.newUser.role
    },
    validPassword () {
      return this.adminPassword
    }
  },
  methods: {
    ...mapActions({ auth: 'auth', getUsers: 'getUsers', createUser: 'createUser', deleteUser: 'deleteUser', updateUser: 'updateUser' }),
    moment,
    async createNewUser () {
      let data = { ...this.newUser }
      data.status = this.newUser.status ? 'active' : 'inactive'

      let response = await this.createUser(data)
      this.$refs['createmodal'].hide()
      if (response) {
        Swal.fire({
          title: 'Done',
          text: 'User has been created',
          // type: 'success',
          heightAuto: false
        })
        this.users = await this.getUsers()
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Something went wrong. Please try again',
          // type: 'error',
          heightAuto: false
        })
      }
    },
    editUserButton (id) {
      let detail = this.users.filter(user => user._id === id)
      this.editUser = Object.assign({}, detail[0])
      this.adminPassword = null
      this.isValidPassword = true
    },
    async saveUpdateUser () {
      let responseData = await this.auth({ username: this.username, password: this.adminPassword })
      this.isValidPassword = responseData.auth
      if (this.isValidPassword) {
        let response = await this.updateUser(this.editUser)
        this.$refs['editmodal'].hide()
        if (response) {
          Swal.fire({
            title: 'Done',
            text: 'User has been updated',
            heightAuto: false
          })
        } else {
          Swal.fire({
            title: 'Error',
            text: 'Something went wrong. Please try again',
            // type: 'error',
            heightAuto: false
          })
        }
        this.users = await this.getUsers()
      }
    },
    deleteAccount (id) {
      Swal.fire({
        title: 'Delete?',
        //    text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then(async (result) => {
        if (result.value) {
          await this.deleteUser(id)
          Swal.fire({
            title: 'Deleted',
            text: '',
            //   type: 'success',
            heightAuto: false
          })
          this.users = await this.getUsers()
        }
      })
    },
    resetCreateModal () {
      this.newUser.username = ''
      this.newUser.password = ''
      this.newUser.role = ''
      this.$refs['createmodal'].hide()
    },
    resetEditModal () {
      this.editUser = {}
      this.adminPassword = null
      this.isValidPassword = true
      this.$refs['editmodal'].hide()
    }
  }
}
</script>
